/**
 * @module businessComponents\mdl\siteComponent\areaComponent
 */
import Vue from "vue";
import Component from "vue-class-component";
import StructBase from "../structBase";
import { Watch } from "vue-property-decorator";
import GhInvoke from "@/components/ghInvoke/ghInvoke";

@Component
export default class AreaComponent extends StructBase {
  private args = { parent_id: "", function: "生产" };

  private checkChanged(item) {
    this.$emit("changed", item);
    this.$emit("input", item);
    let obj = item as IndexObject;
    if (obj.Checked) {
      this.multlSelected[obj.Id] = obj;
    } else {
      delete this.multlSelected.Id;
    }
  }

  private get Selected() {
    return this.multlSelected.map(x => x.Id);
  }

  @Watch("parentId")
  private observeParentId() {
    if (this.parentId) {
      this.args.parent_id = this.parentId;
      let inv = this.$refs.invoke as GhInvoke;
      inv.invoke(this.args);
    }
  }

  @Watch("Selected")
  private observeSelected() {
    this.$emit("input", this.Selected);
  }

  private multlSelected: IndexObject = {};
}
